"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useId, useState, useEffect } from 'react';
import { ComboBoxContext } from './use-combobox.mjs';

const ComboBoxProvider = ({
  value,
  onValueChange,
  schema,
  valueSpec,
  variablesSchema,
  options,
  optionFactories,
  refsToIgnoreClick,
  // Dropdown
  onDropdownOpen,
  onDropdownClose,
  autoOpen,
  topDropdownPanelComponent,
  children
}) => {
  const scopedComboboxId = useId();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  useEffect(() => {
    if (autoOpen) {
      openDropdown();
    }
  }, [autoOpen]);
  function openDropdown() {
    if (isDropdownOpen) return;
    setIsDropdownOpen(true);
    onDropdownOpen?.();
  }
  function closeDropdown() {
    if (!isDropdownOpen) return;
    setIsDropdownOpen(false);
    onDropdownClose?.();
  }
  return /* @__PURE__ */ jsx(
    ComboBoxContext.Provider,
    {
      value: {
        scopedComboboxId,
        value,
        onValueChange,
        schema,
        valueSpec,
        variablesSchema,
        options,
        optionFactories,
        allowCustom: valueSpec?.allowCustom ?? false,
        refsToIgnoreClick,
        isDropdownOpen,
        openDropdown,
        closeDropdown,
        topDropdownPanelComponent
      },
      children
    }
  );
};

export { ComboBoxProvider };
